export default "__VITE_ASSET__CtGibfVx__"